import React from 'react'
import { Link } from 'react-router-dom'
import { Button, Card, Image, Dropdown } from 'semantic-ui-react'
import { addSubscription, unsubscribe, isSubscribed } from '../../services/api-catalog'
import { isAuthenticated } from '../../services/self'
import Usage from '../Usage'

function handleSubscribe(event, usagePlan) {
  event.preventDefault()

  addSubscription(usagePlan.id)
}

function handleUnsubscribe(event, usagePlan) {
  event.preventDefault()

  unsubscribe(usagePlan.id)
}

const SubscribedApiActionsDropdown = ({usagePlan, api}) => (
  <Button style={{fontSize:"14px"}} color="green" size='red' onClick={event => handleUnsubscribe(event, usagePlan)}>Unsubscribe</Button>
  /*<Dropdown text='Actions' button style={{backgroundColor:"#1678C2", color:"white", fontSize:"14px"}} className="big">
    <Dropdown.Menu>
      *<Usage usagePlanId={usagePlan.id}/>
      <Dropdown.Item onClick={event => handleUnsubscribe(event, usagePlan)} style={{fontSize: "14px"}}>Unsubscribe</Dropdown.Item>
    </Dropdown.Menu>
  </Dropdown>}*/)


const ApiCard = ({usagePlan, api}) => (
<Card key={api.id} style={{textAlign: 'center'}}>
  <Link to={`apis/${api.id}`} style={{background: 'white', padding:"25px"}}>{ api.image ? <Image src={api.image} style={{margin:'auto'}}/> : ''}</Link>
  <Card.Content>
    <Card.Header><Link to={`apis/${api.id}`}>{api.swagger.info.title}</Link></Card.Header>
    <Card.Meta>
      <span className='date'>Version {api.swagger.info.version}</span>
    </Card.Meta>
    <Card.Description>{api.swagger.info.description}</Card.Description>
  </Card.Content>
  { isAuthenticated() ? (<Card.Content extra>
    { isSubscribed(usagePlan.id) ? <SubscribedApiActionsDropdown api={api} usagePlan={usagePlan} /> : <Button style={{fontSize:"14px"}} color="green" size='big' onClick={event => handleSubscribe(event, usagePlan)}>Subscribe</Button>}
  </Card.Content>) : ''}
</Card>)

export default ({ catalog }) => (
  <Card.Group itemsPerRow={5} stackable>
    {catalog.map(usagePlan => usagePlan.apis.map(api => ApiCard({usagePlan, api})))}
  </Card.Group>)



/** WEBPACK FOOTER **
 ** ./src/components/ApiCatalog/index.js
 **/